import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'banners',
            name: 'banner',
            class: 'Modules\\Banner\\Entities\\Banner',
            autoLoadBannersHome: true,
            forms: {
                'home.main': {
                    component: 'default-banners-form',
                    alias: 'Home - Principal',
                    tableImage: 'images.small'
                }
            }
        }
    },

    methods: {
        loadHomeBanners() {
            return this.loadIndex({
                scopes: {whereType: 'home.main'},
                paginate: 10,
                placement: 'home_main'
            })
        },

        addForm(type, component, alias, tableImage = 'images.small') {
            this.forms[type] = {
                component: component,
                alias: alias,
                tableImage: tableImage
            }

            return this
        },

        getForm(type) {
            return this.forms[type] ?? {}
        }
    },

    created() {
        if(
            this.autoLoadBannersHome &&
            this.$state.scope == 'web'
        ) {
            this.loadHomeBanners()
        }
    }
}